// Importadora y Distribuidora Uruca — theme.js

document.addEventListener('DOMContentLoaded', function () {

  // Mobile menu toggle
  const menuBtn = document.getElementById('mobile-menu-btn');
  const mobileNav = document.getElementById('mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

  // Search overlay
  const searchBtn = document.getElementById('search-btn');
  const searchOverlay = document.getElementById('search-overlay');
  const searchCloseBtn = document.getElementById('search-close-btn');
  const searchInput = document.getElementById('search-input');

  function openSearch() {
    searchOverlay.classList.add('open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    setTimeout(() => searchInput && searchInput.focus(), 100);
    document.body.style.overflow = 'hidden';
  }

  function closeSearch() {
    searchOverlay.classList.remove('open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (searchBtn) searchBtn.addEventListener('click', openSearch);
  if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);

  // Close on overlay background click
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) closeSearch();
    });
  }

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('open')) {
      closeSearch();
    }
  });

  // Cart count update via AJAX
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-badge').forEach(el => {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});
  }

  // Add to cart AJAX
  document.querySelectorAll('.btn-add').forEach(btn => {
    btn.addEventListener('click', function (e) {
      const form = btn.closest('form');
      if (!form) return;
      e.preventDefault();
      const id = form.querySelector('[name="id"]').value;
      const quantity = form.querySelector('[name="quantity"]') ? parseInt(form.querySelector('[name="quantity"]').value) : 1;

      btn.disabled = true;
      btn.textContent = 'Agregando...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id), quantity })
      })
        .then(r => r.json())
        .then(() => {
          btn.textContent = '✓ Agregado';
          btn.style.background = '#2e7d32';
          updateCartCount();
          setTimeout(() => {
            btn.disabled = false;
            btn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg> Agregar al carrito`;
            btn.style.background = '';
          }, 2000);
        })
        .catch(() => {
          btn.disabled = false;
          btn.textContent = 'Error — intentá de nuevo';
          setTimeout(() => {
            btn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg> Agregar al carrito`;
          }, 2000);
        });
    });
  });

  updateCartCount();
});
(function() {
  function initMarquee() {
    const bar = document.querySelector('.announce-bar');
    if (bar) {
      const text = bar.innerHTML;
      bar.innerHTML = '<span style="display:inline-block;animation:marquee 20s linear infinite;white-space:nowrap;">' + text + '</span>';
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarquee);
  } else {
    initMarquee();
  }
})();
